import { FC } from "react";
import { IconProps } from "./interface";

const Orders: FC<IconProps> = (props) => {
  const { fillColor, size, title } = props;
  return (
    <svg
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
    >
      {title && <title>{title}</title>}

      <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
        <path
          fill={fillColor}
          d="M 69.541 90 H 20.459 c -3.175 0 -5.758 -2.583 -5.758 -5.759 v -64.93 c 0 -3.175 2.583 -5.758 5.758 -5.758 h 8.855 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 h -8.855 c -0.97 0 -1.758 0.789 -1.758 1.758 v 64.93 c 0 0.97 0.789 1.759 1.758 1.759 h 49.082 c 0.97 0 1.759 -0.789 1.759 -1.759 v -64.93 c 0 -0.97 -0.789 -1.758 -1.759 -1.758 h -8.855 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 8.855 c 3.176 0 5.759 2.583 5.759 5.758 v 64.93 C 75.3 87.417 72.717 90 69.541 90 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 60.686 20.988 H 29.314 c -1.104 0 -2 -0.896 -2 -2 v -3.32 c 0 -5.522 4.255 -10.069 9.659 -10.534 C 38.4 2.049 41.514 0 45 0 c 3.485 0 6.6 2.049 8.026 5.134 c 5.404 0.465 9.659 5.012 9.659 10.534 v 3.32 C 62.686 20.093 61.79 20.988 60.686 20.988 z M 31.314 16.988 h 27.372 v -1.32 c 0 -3.625 -2.949 -6.573 -6.573 -6.573 h -0.497 c -0.907 0 -1.701 -0.611 -1.934 -1.488 C 49.119 5.483 47.194 4 45 4 c -2.194 0 -4.12 1.483 -4.683 3.607 c -0.232 0.877 -1.026 1.488 -1.933 1.488 h -0.497 c -3.625 0 -6.573 2.949 -6.573 6.573 V 16.988 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 47.346 13.27 h -4.692 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 4.692 c 1.104 0 2 0.896 2 2 S 48.45 13.27 47.346 13.27 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 31.336 59.59 h -4.835 c -1.806 0 -3.275 -1.47 -3.275 -3.275 v -4.835 c 0 -1.806 1.469 -3.275 3.275 -3.275 h 4.835 c 1.806 0 3.275 1.47 3.275 3.275 v 4.835 C 34.611 58.12 33.142 59.59 31.336 59.59 z M 27.226 55.59 h 3.385 v -3.386 h -3.385 V 55.59 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 63.834 52.204 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 23.845 c 1.104 0 2 0.896 2 2 S 64.938 52.204 63.834 52.204 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 52.479 59.59 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 12.491 c 1.104 0 2 0.896 2 2 S 53.584 59.59 52.479 59.59 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 28.18 41.578 c -0.638 0 -1.239 -0.304 -1.616 -0.822 l -2.954 -4.054 c -0.651 -0.893 -0.455 -2.144 0.438 -2.794 c 0.893 -0.651 2.144 -0.455 2.794 0.438 l 1.176 1.614 l 2.878 -4.796 c 0.568 -0.947 1.797 -1.255 2.744 -0.686 c 0.947 0.568 1.254 1.797 0.686 2.744 l -4.431 7.385 c -0.345 0.575 -0.956 0.939 -1.625 0.969 C 28.24 41.577 28.21 41.578 28.18 41.578 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 63.834 34.192 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 23.845 c 1.104 0 2 0.896 2 2 S 64.938 34.192 63.834 34.192 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 52.479 41.578 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 12.491 c 1.104 0 2 0.896 2 2 S 53.584 41.578 52.479 41.578 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 31.336 78.372 h -4.835 c -1.806 0 -3.275 -1.47 -3.275 -3.275 v -4.835 c 0 -1.806 1.469 -3.275 3.275 -3.275 h 4.835 c 1.806 0 3.275 1.47 3.275 3.275 v 4.835 C 34.611 76.902 33.142 78.372 31.336 78.372 z M 27.226 74.372 h 3.385 v -3.386 h -3.385 V 74.372 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 63.834 70.986 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 23.845 c 1.104 0 2 0.896 2 2 S 64.938 70.986 63.834 70.986 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
        <path
          fill={fillColor}
          d="M 52.479 78.372 H 39.989 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 12.491 c 1.104 0 2 0.896 2 2 S 53.584 78.372 52.479 78.372 z"
          transform=" matrix(1 0 0 1 0 0) "
        />
      </g>
    </svg>
  );
};

export default Orders;
